import { render, staticRenderFns } from "./OpenedApp.vue?vue&type=template&id=351ae761&"
import script from "./OpenedApp.vue?vue&type=script&lang=js&"
export * from "./OpenedApp.vue?vue&type=script&lang=js&"
import style0 from "./OpenedApp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports